// extracted by mini-css-extract-plugin
export default {"stripe":"Stripe_stripe__l0lC8"};